<template>
    <div v-if="categoriesSearchResults.length > 0" class="suggest-result">
        <h3>{{ __('frontend_js.search.categories') }}</h3>
        <ul>
            <li v-for="category in categoriesSearchResults" :key="category.category_id">
                <a :href="category.slug" class="hover-remove-underline text-dark">
                    {{ category.elasticTitle }}
                    <span v-if="category.isOnSale == true || category.isNewCollection == true">-</span>
                    <span v-if="category.isOnSale == true">
                        {{ __('frontend_js.search.is_on_sale') }}
                    </span>
                    <span v-if="category.isNewCollection == true">
                        {{ __('frontend_js.search.is_new_collection') }}
                    </span>
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        categoriesSearchResults: {
            type: Array,
        },
    },
};
</script>
